import {Enum} from "~/enums/index";

export default new Enum({
    JOB_PROFILE: "JOB_PROFILE",
    CANDIDATE_PROFILE: "CANDIDATE_PROFILE",
    PROFILE: "PROFILE",
});
